import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'דני כהן',
    location: 'תל אביב',
    text: 'קראתי ליבש-טק פרו אחרי שהרצפה שלי הייתה רטובה שבועיים והפרקט התחיל להתנפח. הגיעו תוך שעה, איתרו את הפיצוץ וייבשו הכל תוך יום. שירות מדהים!',
    stars: 5
  }, {
    name: 'רחל לוי',
    location: 'חיפה',
    text: 'המקצועיות והמהירות שלהם הפתיעו אותי לטובה. המחיר היה הוגן מאוד ביחס להצעות אחרות, והם עבדו בצורה נקייה ומסודרת. ממליצה בחום לכל מי שיש לו רטיבות.',
    stars: 5
  }, {
    name: 'משה אברהם',
    location: 'ירושלים',
    text: 'הייתה לנו בעיית רטיבות כרונית בקיר הסלון שנמשכה שנים. הם הגיעו, אבחנו תוך דקות ופתרו את הבעיה מהשורש. סוף סוף הקיר יבש! תודה רבה.',
    stars: 5
  }];
  return <section className="py-20 bg-[#f5f5f7] px-4 md:px-8" data-id="element-178">
      <div className="max-w-7xl mx-auto" data-id="element-179">
        <div className="text-center mb-16" data-id="element-180">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-181">
            מה הלקוחות שלנו אומרים?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-182">
            אלפי לקוחות מרוצים כבר בחרו בנו
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-183">
          {reviews.map((review, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm relative" data-id="element-184">
              <QuoteIcon className="absolute top-6 left-6 w-10 h-10 text-gray-100 rotate-180" data-id="element-185" />

              <div className="flex gap-1 mb-4" data-id="element-186">
                {[...Array(review.stars)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-187" />)}
              </div>

              <p className="text-gray-700 text-lg mb-6 leading-relaxed relative z-10" data-id="element-188">
                "{review.text}"
              </p>

              <div className="flex items-center gap-3 border-t border-gray-100 pt-4" data-id="element-189">
                <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center font-bold text-gray-500" data-id="element-190">
                  {review.name[0]}
                </div>
                <div data-id="element-191">
                  <div className="font-bold text-gray-900" data-id="element-192">{review.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-193">{review.location}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}